export const unitStatusConstants = {
  LOAD: 'unitStatus/LOAD',
  LOAD_SUCCESS: 'unitStatus/LOAD_SUCCESS',
  LOAD_FAIL: 'unitStatus/LOAD_FAIL',
  FLUSH: 'unitStatus/FLUSH',
  ALL_UNIT_STATUS: 'unitStatus/ALL_UNIT_STATUS',
};
